import {ClientConfig, HttpClient} from '../../http';
import {toURLParams} from '@stryd/util-lib/urls/toURLParams';
import {NewsletterSignupParams} from '@stryd/models';

export const setupEmailEndpoints = (client: HttpClient) => {
  const basePath = `/canyon/email/subscribe`;
  const urlPrefixBackend = `/b/api/v1/users`;

  return {
    signupForList: (params: NewsletterSignupParams, configs?: ClientConfig) => {
      const {email, tags, list} = params;
      const joinedTags = tags ? tags.join(',') : '';
      const urlParams = toURLParams({list, tags: joinedTags, email});

      return client.post(`${basePath}?${urlParams}`, configs);
    },

    verifyEmail: (
      params: {userId: string; code: string},
      configs?: ClientConfig
    ) => {
      const {userId, code} = params;

      return client.post(
        `${urlPrefixBackend}/${userId}/email/verify`,
        {code},
        configs
      );
    },

    sendEmailVerificationCode: (
      params: {userId: string},
      configs?: ClientConfig
    ) => {
      const {userId} = params;

      return client.post(
        `${urlPrefixBackend}/${userId}/email/send-verification-code`,
        configs
      );
    },
  };
};
